module.exports = __webpack_public_path__ + "img/userB24.df97d00b.jpg";